var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGestor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.309 13.7506H11.5581C11.4632 13.7506 11.3769 13.8116 11.3467 13.9074C10.7771 15.6576 9.18046 16.82 7.36377 16.82C7.34219 16.82 7.3163 16.82 7.29473 16.82C5.03789 16.7852 3.18667 14.9 3.16941 12.623C3.16078 11.4867 3.5923 10.4201 4.3863 9.61027C5.18029 8.80048 6.23751 8.3564 7.36377 8.3564H12.5031C12.6283 8.3564 12.7275 8.25626 12.7275 8.13001V7.40294C12.7275 7.27668 12.6283 7.17654 12.5031 7.17654H7.41124C5.98291 7.17654 4.63226 7.74253 3.60093 8.76565C2.5696 9.79312 2.00432 11.1471 2 12.5839C2 14.0293 2.55666 15.3876 3.57073 16.4108C4.58479 17.4339 5.93113 17.9999 7.35945 17.9999C8.55476 17.9999 9.68534 17.6124 10.6304 16.8766C11.5452 16.1626 12.2183 15.1569 12.529 14.0423C12.5463 13.9727 12.5334 13.903 12.4902 13.8464C12.4471 13.7855 12.3823 13.7506 12.309 13.7506Z",
    fill: "url(#paint0_linear_1385_17780)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6813 5.38274C17.4138 4.72968 17.0254 4.13758 16.5291 3.63255C15.5064 2.58331 14.1515 2.00426 12.7145 1.99991C12.7102 1.99991 12.7102 1.99991 12.7059 1.99991C10.2937 1.99991 8.16201 3.6369 7.52336 5.98355C7.5061 6.05321 7.51905 6.12287 7.5622 6.18382C7.60535 6.24042 7.67008 6.2709 7.73912 6.2709H8.49428C8.59353 6.2709 8.67552 6.20994 8.70572 6.11416C9.27101 4.35091 10.8763 3.17976 12.7059 3.17976C12.7275 3.17976 12.749 3.17976 12.7706 3.17976C15.0836 3.21459 16.9434 5.14329 16.9132 7.47687C16.883 9.78434 14.9973 11.6651 12.7102 11.6651H7.55789C7.43275 11.6651 7.3335 11.7653 7.3335 11.8915V12.6186C7.3335 12.7449 7.43275 12.845 7.55789 12.845H12.7102C14.1299 12.845 15.4676 12.2921 16.4817 11.282C17.4957 10.2763 18.0654 8.93537 18.0869 7.50735C18.0956 6.77593 17.9618 6.06192 17.6813 5.38274Z",
    fill: "url(#paint1_linear_1385_17780)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1385_17780",
    x1: 6.11944,
    y1: 15.6095,
    x2: 14.7653,
    y2: -5.02456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0145945,
    stopColor: "#68BAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0935566,
    stopColor: "#5FA9AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4101,
    stopColor: "#3D6A75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6775,
    stopColor: "#253B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8823,
    stopColor: "#161F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10142D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1385_17780",
    x1: 8.86697,
    y1: 16.7607,
    x2: 17.5128,
    y2: -3.87337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0145945,
    stopColor: "#68BAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0935566,
    stopColor: "#5FA9AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4101,
    stopColor: "#3D6A75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6775,
    stopColor: "#253B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8823,
    stopColor: "#161F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10142D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestor);
export default __webpack_public_path__ + "static/media/gestor.ecb407c9dcdd4a67f7daea63db9125e3.svg";
export { ForwardRef as ReactComponent };